<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="show">
        <div class="u-window msg-modal">
            <div class="dialog-content">
                <div class="dialog-wrapper">
                    <p class="notice" v-if="reward > 0">恭喜您抽中火炬手随机点亮卡 请点击下方参与活动。</p>
                    <p class="notice" v-if="reward == 8">恭喜您抽中了纪念熊猫 请在下方填写地址。</p>

                    <div class="u-btn submit" @click="close"></div>
                </div>
            </div>
        </div>
        <div class="u-mask" @click="close"></div>
    </div>
</transition>
</template>

<script>
  export default {
    name: 'rewardNotice',
    data(){
        return {
            cshow : true,
        }
    },
    props: {
      text: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: false
      },
      reward : {
        default : 0,
      }
    },
    beforeDestroy() {
        //this.$el && this.$el.parentNode.removeChild(this.$el)
    },    
    methods: {
        call_login(){
            mslogin.open();
            //console.log(this);
        },
        close(){
            this.$destroy(true)  //销毁组件
            this.$el.parentNode.removeChild(this.$el)  //父元素中移除dom元素（$el为组件实例）
            localStorage.setItem('oshirase', 1)
        },
        switch_update(boolean){
            this.show = boolean;
        },     
    },
  }
</script>

<style>
    /* .msg-modal{
        width: 5.7rem;
        background-color: #000000;
    } */

    .msg-modal .dialog-content{
        position: relative;
        width: 6.68rem;
        height: 4.37rem;
        margin: 0 auto;
        background-image: url(~@/assets/images/bg-modal-area.png);
    }

    .msg-modal .dialog-wrapper{
        padding: 1.2rem .5rem 0;
    }    

    .msg-modal .notice{
        margin-bottom: .5rem;
        text-align: center;
        color: #ffac73;
        font-size: .24rem;
    }

    .msg-modal .u-btn.submit{
        position: absolute;
        width: 2.46rem;
        height: .89rem;
        left: 50%;
        bottom: .4rem;
        transform: translateX(-50%);
        background-image: url(~@/assets/images/btn-check.png);    
    }        
</style>


// WEBPACK FOOTER //
// src/components/oshirase.vue